<template>
  <div v-if="result">
    <div class="txt-result">‘{{ result.value }}’ 검색결과</div>

    <div class="tab-wrapper">
      <div class="tab-item unselect" :class="{'tab-item-selected': selectedMenu === 0}"
           @click="selectedMenu=0">메뉴 {{ result.list.length }}</div>
      <div class="tab-item unselect" :class="{'tab-item-selected': selectedMenu === 1}"
           @click="selectedMenu=1">앱마켓 {{ appCount }}</div>
    </div>
    <!-- 메뉴 검색 결과 -->
    <div class="tab-content" v-show="selectedMenu === 0">
      <template v-if="result && result.list.length>0">
        <div class="item-menu unselect" v-for="(menu,idx) in result.list" :key="`menu-item-${idx}`" @click="clickMenu(menu)">
          <div class="menu-name">{{ menu.name }}</div>
          <div class="menu-desc">{{ menu.path_name }}</div>
        </div>
      </template>
      <div v-else class="empty-view">
        <div class="body1 sub">검색결과가 없습니다.</div>
        <div class="body2 sub2" style="margin:24px 0 12px 0">찾으시는 검색결과가 없으신가요?<br>메뉴얼을 참고해주세요.</div>
        <a href="https://launchpack.notion.site/launchpack/v-2-LAUNCH-PACK-a3d47b98fef04bbbaeb58d10684f6b5b" target="_blank">
          <div class="button is-gray">관리자 메뉴얼 보기</div>
        </a>
      </div>
    </div>
    <!-- 앱마켓 검색 결과 -->
    <div class="tab-content" v-show="selectedMenu === 1">
        <market v-if="result" :search="result.value" @count="res => appCount = res"></market>
      <div v-if="appCount === 0" class="empty-view">
        <div class="body1 sub">검색결과가 없습니다.</div>
        <div class="body2 sub2" style="margin:24px 0 12px 0">찾으시는 검색결과가 없으신가요?<br>메뉴얼을 참고해주세요.</div>
        <a href="https://launchpack.notion.site/launchpack/v-2-LAUNCH-PACK-a3d47b98fef04bbbaeb58d10684f6b5b" target="_blank">
          <div class="button is-gray">관리자 메뉴얼 보기</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import Market from "./Market";

  export default {
    name: "SearchResult",
    components: {Market},
    created() {
      this.result = this.$store.getters.searchResult;
    },
    data() {
      return {
        result: undefined,
        appCount: 0,
        selectedMenu: 0
      }
    },
    methods: {
      clickMenu(menu) {
        this.routerPush(this.getPath(menu.path));
      },
    },
    watch: {
      '$store.getters.searchResult'(n) {
        this.appCount = 0;
        this.result = n;
      },
      appCount(n) {
        if(this.result.list.length === 0 && n > 0) {
          this.selectedMenu = 1;
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import 'market_style.styl'
  .txt-result
    margin-bottom 16px
    color #363636
    font-size 20px
    font-weight 700

  .tab-wrapper
    border-bottom 1px solid #cccccc
    display flex
    margin-bottom 16px
  .tab-item
    width 87px
    height 40px
    line-height 40px
    border-bottom 2px transparent
    font-size 14px
    text-align center
  .tab-item-selected
    font-weight 700
    border-bottom 2px solid #363636

  .item-menu
    border 1px solid #cccccc
    border-radius 6px
    padding 12px 20px
    background-color white
    margin-bottom 8px
  .menu-name
    font-size 14px
    font-weight 500
    color #363636
  .menu-desc
    font-size 12px
    color #989898
    margin-top 2px

  .item-menu:hover
    .menu-name
      color #ff5722
  .empty-view
    margin-top 36px
    text-align center
    .sub
      color #787878
    .sub2
      color #989898
    .button
      font-weight 400 !important
      width 154px !important
      height 32px !important
      font-size 13px

</style>
